import React from 'react';
import { useSelector } from 'react-redux'
//import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { useDispatch } from 'react-redux'
//import { setVideoPlayerAudioTrack } from 'src/shared/video/video_room/player/actions'
//import { Liquid } from 'liquidjs'
import RenderedHtmlContent from "src/shared/virtual_congress/components/rendered_html_content";

// Deprecated, just use <RenderedHtmlContent identifier="...html-content.identifier"/>. Works for now only as a wrapper for RenderedHtmlContent anymore.
export default function HtmlContent({identifier, id, ...props }) {
  const dispatch = useDispatch()

  const htmlContents = useSelector(state => state.htmlContents)
  const tagOwner = useSelector(state => state.tagOwner)
  const htmlContent = htmlContents ? htmlContents.find(hc => id ? hc.id == id : hc.identifier == identifier) : null
  //const engine = new Liquid()

  if(htmlContents == null) {
    console.error("Tried to render HtmlContent", identifier, id, "but no htmlContents present in state")
    return null
  }

  if(htmlContent == null) {
    console.error("Tried to render HtmlContent", identifier, id, "but no htmlContent with this id or identifier found")
    return null
  }

  let html = htmlContent.html

  return <RenderedHtmlContent html={html}/>

  // if(props.renderLiquid != false) {
  //   try {
  //     let tpl = engine.parse(html)
  //     html = engine.renderSync(tpl, {tagOwner: tagOwner})
  //   } catch(ex) {
  //     console.error(ex)
  //   }
  // }

  // const options = { 
  //   replace: (node) => {
  //     if(node.attribs && node.attribs.role == "videoroom-language-switcher" && node.attribs["data-language"]) {
  //       const nodeProps = attributesToProps(node.attribs);
  //       return <div onClick={() => { dispatch(setVideoPlayerAudioTrack(node.attribs["data-language"]))}} {...nodeProps}>
  //         {domToReact(node.children, options)}
  //       </div>
  //     }
  //   } 
  // }

  // return parse(html, options)
}